// eslint-disable-next-line lingui/no-unlocalized-strings
const active = "[&_path]:fill-white bg-[#399E82] text-white";
// eslint-disable-next-line lingui/no-unlocalized-strings
const inactive = "[&_path]:fill-[#85C4B3] text-[#85C4B3]";
const getClassName = ({ isActive }: { isActive: boolean }) =>
  // eslint-disable-next-line lingui/no-unlocalized-strings
  `${isActive ? active : inactive} flex w-full justify-center py-3 relative`;

export { active, getClassName };
